import Page from 'components/ui/Page'
import PropTypes from 'prop-types'
import React from 'react'
import { useParams } from 'react-router-dom'
import EventView from './EventView'

const EventViewPage = () => {
    const { id } = useParams()
    return (
        <Page title="Events">
            <EventView eventId={id} />
        </Page>
    )
}

EventViewPage.propTypes = {
    eventId: PropTypes.any,
}

export default EventViewPage
